module.exports = __webpack_public_path__ + "static/media/gamejam1.149f0dd9.JPG";